import { createContext } from "react";

const PlanMasterContext = createContext({});

export default PlanMasterContext;
